import React from 'react';

import { StyledNotFound, NotFoundHeading } from './NotFound.styles';

export const NotFound = () => (
  <StyledNotFound>
    <NotFoundHeading>Page not found</NotFoundHeading>
  </StyledNotFound>
);

export default NotFound;
